<template>
    <mdb-navbar color="white" light>
        <mdb-navbar-brand tag="a" to="/" waves>
            <img src="/logo.png" style="height:50px;">
        </mdb-navbar-brand>
        <mdb-navbar-toggler>
            <mdb-navbar-nav right>
                <mdb-dropdown tag="li" class="nav-item">
                    <mdb-dropdown-toggle tag="a" navLink color="white" slot="toggle" waves-fixed>{{this.$store.state.username}}</mdb-dropdown-toggle>
                    <mdb-dropdown-menu>
                        <mdb-dropdown-item v-on:click="gotoadmin" v-if="this.$store.state.isadmin">Administration</mdb-dropdown-item>
                        <mdb-dropdown-item v-on:click="gotoprofile">Mon profil</mdb-dropdown-item>
                        <mdb-dropdown-item v-on:click="logout">Déconnexion</mdb-dropdown-item>
                    </mdb-dropdown-menu>
                </mdb-dropdown>
            </mdb-navbar-nav>
        </mdb-navbar-toggler>
    </mdb-navbar>
</template>

<script>
    import {
        mdbNavbar, mdbNavbarBrand, mdbNavbarNav, mdbNavbarToggler, mdbDropdown, mdbDropdownToggle, mdbDropdownMenu, mdbDropdownItem,
    } from 'mdbvue';

    import Auth from '../libs/Auth';

    export default {
        name: 'Vedheader',
        data() {
            return {
                username: 'Sylvain Mallet ',
                showmyaccount: false,
            };
        },
        components: {
            mdbNavbar,
            mdbNavbarBrand,
            mdbNavbarNav,
            mdbNavbarToggler,
            mdbDropdown,
            mdbDropdownToggle,
            mdbDropdownMenu,
            mdbDropdownItem,
        },
        methods: {
            logout() {
                const auth = new Auth();
                auth.logout();
                this.$router.push({ name: 'Login' });
            },

            gotoadmin() {
                this.$router.push({ name: 'Admin' });
            },

            gotoprofile() {
                this.$router.push({ name: 'Profile' });
            },
        },
    };
</script>
